import React from 'react';
import { ButtonProps, Button, useThemedValueSwitch } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export interface ToggleButtonProps extends ButtonProps {
  active?: boolean;
  value: string | number;
}
export const ToggleButton: React.FC<ToggleButtonProps> = ({
  children,
  active,
  ...buttonProps
}) => {
  const { tvs } = useThemedValueSwitch();

  const defaultProps: ButtonProps = {
    cursor: 'pointer',
    maxWidth: 'auto',
    minWidth: 'auto !important',
    isFullWidth: true,
  };
  const activeStyles: ButtonProps = {
    bgColor: tvs({ tq: 'blue.100' }, COLOURS.blue[150]),
    color: COLOURS.black,
    sx: {
      ':focus': {
        bgColor: tvs({ ni: COLOURS.blue[150] }),
        color: COLOURS.black,
        outline: 'none',
        border: 'none',
      },
    },
  };
  const inactiveStyles: ButtonProps = {
    bgColor: tvs({ tq: 'grey.100' }, COLOURS.gray[240]),
    color: tvs({ tq: 'blue.600' }),
  };

  const styles = active ? activeStyles : inactiveStyles;

  return (
    <Button {...defaultProps} {...styles} {...buttonProps}>
      {children}
    </Button>
  );
};
